
import { defineComponent, ref, toRef, watch } from "vue";
import VZModal from "@/components/content/VZModal.vue";
import { TranslationService } from "@/core/services/TranslationService";
export default defineComponent({
  emit: ["close-detail"],
  name: "DiscardConfirmationModal",
  inheritAttrs: false,
  components: {
    VZModal,
  },
  props: {
    loading: { type: Boolean, default: false },
    showDialog: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const close = () => {
      emit("close-detail");
    };

    return {
      close,
      t,
    };
  },
});
